import { Box, Flex, Heading } from '@chakra-ui/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../components/Header';
import Paginator from '../../components/Paginator';
import WalletInfo from '../Wallet/WalletInfo';
import WalletPassphrase from '../Wallet/WalletPassphrase';
import WalletPasswordSetup from '../Wallet/WalletPasswordSetup';
import EnterUserType from './pages/EnterUserType';

enum Page {
  Info = 0,
  Twitter,
  WalletInfo,
  WalletPasswordSetup,
  WalletPassphrase,
}

const Enter = () => {
  const [page, setPage] = useState(Page.Info);

  const history = useHistory();

  return (
    <>
      <Header h="5rem" borderRadius="0 0 2px 2px" />
      <Flex flexDir="column" alignItems="center" p={8}>
        <Paginator index={page}>
          <Heading size="lg" mb={8}>
            Select User Type
          </Heading>
          <Heading size="lg" mb={8}>
            A good influencer page could use a few more details about you
          </Heading>
        </Paginator>

        <Box bg="white" w="1000px" borderRadius="8px" overflow="hidden">
          <Paginator index={page}>
            <EnterUserType
              nextPage={() => {
                if (localStorage.getItem('encryptedMnemonic')) {
                  history.push('/dashboard');
                } else {
                  history.push('/recover');
                }
              }}
            />

            <Box p={8}>
              <WalletInfo
                onBack={() => setPage(Page.Twitter)}
                onNext={() => setPage(Page.WalletPasswordSetup)}
              />
            </Box>
            <Box p={8}>
              <WalletPasswordSetup
                onBack={() => setPage(Page.Twitter)}
                onNext={() => setPage(Page.WalletPassphrase)}
              />
            </Box>

            <Box p={8}>
              <WalletPassphrase
                onBack={() => setPage(Page.WalletPasswordSetup)}
                onNext={() => history.replace('/dashboard')}
              />
            </Box>
          </Paginator>
        </Box>
      </Flex>
    </>
  );
};

export default Enter;
